var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols",
    attrs: {
      "sendEmail": _vm.sendEmail
    }
  }, [_c('b-row', {
    staticClass: "mt-5",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('h1', [_vm._v("Contact")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('b-form-group', {
    staticClass: "textLeft",
    attrs: {
      "id": "exampleInputGroup1",
      "label": "Email address:",
      "label-for": "exampleInput1"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "exampleInput1",
      "type": "email",
      "required": "",
      "placeholder": "Enter email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "textLeft",
    attrs: {
      "id": "exampleInputGroup2",
      "label": "Your Name:",
      "label-for": "exampleInput2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "exampleInput2",
      "type": "text",
      "required": "",
      "placeholder": "Enter name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "textLeft",
    attrs: {
      "id": "exampleInputGroup2",
      "label": "Your message:",
      "label-for": "exampleInput3"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "textarea1",
      "placeholder": "Enter message",
      "rows": 3,
      "max-rows": 6
    },
    model: {
      value: (_vm.form.message),
      callback: function($$v) {
        _vm.form.message = $$v
      },
      expression: "form.message"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "onClick": _vm.sendEmail
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('b-jumbotron', {
    attrs: {
      "header": "Contact me",
      "lead": "You can contact with me for instance"
    }
  }, [_c('p', [_vm._v("Email: mikephotography@example.com")]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('p', [_vm._v("Phone: 608-333-666")]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center mb-5 cf"
  }, _vm._l((_vm.media), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "2",
        "sm": "2",
        "md": "2",
        "lg": "2"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgWhite
      }
    }), _c('img', {
      staticClass: "top",
      attrs: {
        "src": item.imgHover
      }
    })])])
  }))], 1)], 1)], 1)], 1)], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b646a8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = +1ju
// module chunks = 0